import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { BrokerFeedbackService } from '@shared/services/broker-feedback.service';
import { EVENT_DISPATCHER_KEYS, EventDispatcherService } from '@shared/services/utils/event-disptacher-service';

interface FeedbackDialogData {
  recordId: number;
  entityType: string;
  userId: number;
  usage: string;
  tab: string;
}

interface FeedbackPayload {
  feedbackNotes: string;
  recordId: number;
  entity: string;
  userId: number;
}

@Component({
  selector: 'miq-broker-feedback-dialog',
  templateUrl: './broker-feedback-dialog.component.html',
  styleUrls: ['./broker-feedback-dialog.component.scss'],
  standalone: false,
})
export class BrokerFeedbackDialogComponent implements OnInit {
  feedbackForm: FormGroup;
  isLoading = false;

  constructor(
    private fb: FormBuilder,
    private brokerFeedbackService: BrokerFeedbackService,
    private dialogRef: MatDialogRef<BrokerFeedbackDialogComponent>,
    private eventDispatcher: EventDispatcherService,
    @Inject(MAT_DIALOG_DATA) public dialogData: FeedbackDialogData
  ) {
    this.initForm();
  }

  ngOnInit(): void {}

  private initForm(): void {
    this.feedbackForm = this.fb.group({
      feedback_notes: ['', Validators.required],
    });
  }

  closePopup(): void {
    this.dialogRef.close();
  }

  onSubmit(): void {
    if (this.feedbackForm.invalid) return;
    this.isLoading = true;
    const payload = this.getFeedbackPayload();
    this.submitFeedback(payload);
  }

  private getFeedbackPayload(): FeedbackPayload {
    const feedbackNotes = this.feedbackForm.value.feedback_notes;

    return {
      feedbackNotes,
      recordId: this.dialogData.recordId,
      entity: this.dialogData.entityType,
      userId: this.dialogData.userId,
    };
  }
  private submitFeedback(payload: FeedbackPayload): void {
    this.brokerFeedbackService
      .brokerFeedback(
        payload.entity,
        payload.recordId,
        payload.userId,
        payload.feedbackNotes,
        this.dialogData.tab,
        this.dialogData.usage
      )
      .subscribe({
        next: () => {
          this.dialogRef.close(payload);
          this.eventDispatcher.emitEvent({
            eventKey: EVENT_DISPATCHER_KEYS.FeedBackSubmitted,
            event: payload,
          });
          this.isLoading = false;
        },
        error: () => {
          this.isLoading = false;
        },
      });
  }
}
